import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "../../../../../../../ui/Dialog/DialogTitle";
import DialogContent from "../../../../../../../ui/Dialog/DialogContent";
import DialogActions from "../../../../../../../ui/Dialog/DialogActions";
import AddInventTypeForm from "../AddInventTypeForm";
import { updateResourceType } from "../../../store/send";
import { getResourceType } from "../../../store/actions";

const styles = () => ({
  dialog: {
    width: "550px"
  }
});

const UpdateInventTypeModal = ({
  open,
  handleClose,
  resTypeId,
  restypeCard,
  getResourceType,
  updateResourceType,
  isUpdatingResType,
  updatedResType,
  classes
}) => {
  const [formData, updateFormData] = useState(null);
  const [card, setCard] = useState(null);

  useEffect(() => {
    if (resTypeId !== -1) {
      setCard(null);
      getResourceType(resTypeId);
    }
  }, [getResourceType, resTypeId]);

  useEffect(() => {
    setCard(restypeCard);
  }, [restypeCard]);

  const onConfirm = () => {
    if (resTypeId && resTypeId !== -1){
      updateResourceType(resTypeId,formData);
    }
  };

  const onClose = () => {
    updateFormData(null);
    handleClose();
  };

  useEffect(() => {
    if (updatedResType && updatedResType.success) {
      handleClose();
    }
  }, [handleClose, updatedResType]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Обновить тип ресурса</DialogTitle>
        <DialogContent>
          {card &&
          <AddInventTypeForm
            onFormChange={updateFormData}
            disabled={isUpdatingResType}
            initialData={card}
          />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isUpdatingResType}
            disabled={isUpdatingResType}
            onClick={() => onConfirm()}
            color="green"
          >
            Сохранить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const mapStateToProps = state => ({
  isUpdatingResType: state.nomenclature.isUpdatingResType,
  updatedResType: state.nomenclature.updatedResType,
  restypeCard: state.nomenclature.restypeCard
});

const mapDispatchToProps = dispatch => ({
  updateResourceType: (id,data) => dispatch(updateResourceType(id,data)),
  getResourceType: (id) => dispatch(getResourceType(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withRouter(UpdateInventTypeModal)));
